export const ANTALYA_LOCATION_ARTICLE_SLUGS = new Set([
  "doctor-in-antalya-tourist-medical-help",
  "doctor-hotel-visit-antalya",
  "english-speaking-doctor-antalya",
  "private-doctor-antalya-tourist",
]);

export function linksToAntalyaLocations(slug: string): boolean {
  return ANTALYA_LOCATION_ARTICLE_SLUGS.has(slug);
}
